const 
    MINUTE_IN_SECONDS = 60,
    HOUR_IN_SECONDS = ( 60 * MINUTE_IN_SECONDS )
;

var Dates = {

    inited : false,

    init : function(){

        Dates.checkItems();

        // Add to pager
        if( !this.inited ){
            
            this.inited = true;

            if( typeof Pager !== 'undefined' ){
                Pager.addCallback( Dates.checkItems );
            }
        
        }

    },

    checkItems : function(){

        $( 'time[data-datetime]' ).each(function(){

            var descDate;
            switch( this.dataset.datetimeStyle ){
                case '2':
                    descDate = Dates.styleTwo( this );
                break;
                case '3':
                    descDate = Dates.styleThree( this );
                break;
                default:
                    descDate = Dates.styleDefault( this );
                break;
            }

            this.innerHTML = descDate;
            this.classList.add( 'ready' );
        
        });

    },

    styleDefault : function( item ){

        var 
            date = new Date( item.dataset.datetime ),
            time =  date.getTime(),
            descDate = ''
        ;

        // Today
        if( Dates.isToday( date ) ){
            return Dates.timeAgo( time );
        }
        // Yestarday
        else if( Dates.isYesterday( date ) ){
            return 'Ontem';
        }
        // Older
        else {
            return item.dataset.datetimeFormated;
        }

    },

    styleTwo : function( item ){

        const 
            date = new Date( item.dataset.datetime ),
            time = date.getTime() / 1000,
            dateNow = new Date(),
            timeNow = dateNow.getTime() / 1000
        ;

        // Hoje
        if( Dates.isToday( date ) ){

            var diffHours = ( timeNow - time  ) / HOUR_IN_SECONDS;
            if( diffHours < 1 ){
                const diffMinuts = Math.ceil( ( timeNow - time ) / MINUTE_IN_SECONDS );
                return 'Atualizado há ' + diffMinuts + ' minuto' + ( diffMinuts > 1 ? 's' : '' );
            }
            else if( diffHours <= 6 ){
                diffHours = Math.ceil( diffHours );
                return 'Atualizado há ' + diffHours + ' hora' + ( diffHours > 1 ? 's' : '' );
            }
            else {
                return 'Hoje às ' + Dates.formatHour( date );
            }

        // Ontem
        }
        else if( Dates.isYesterday( date ) ){

           return 'Ontem às ' + Dates.formatHour( date );
        
        }
        else {

            return item.dataset.datetimeFormated;

        }

        return descDate;

    },

    styleThree : function( item ){

        const date = new Date( item.dataset.datetime );

        if( Dates.isToday( date ) || Dates.isYesterday( date ) ){
            return ( Dates.isYesterday( date ) ? 'Ontem' : 'Hoje' ) + ' às ' + Dates.formatHour( date );
        }
        else {
            return item.dataset.datetimeFormated;
        }

    },

    // Check if date is Today
    isToday : function( date ){

        const today = new Date();
        return Dates.compareDate( today ) === Dates.compareDate( date );

    },

    // Check if date is Yesterday
    isYesterday : function( date ){

        const yesterday = new Date();
        yesterday.setDate( yesterday.getDate() - 1 );
        return Dates.compareDate( yesterday ) === Dates.compareDate( date );

    },

    formatHour : function( date ){
        return date.getHours().toString().padStart( 2, '0' ) + ':' +  date.getMinutes().toString().padStart( 2, '0' );
    },

    compareDate : function( date ){
        return date.getFullYear() + '-' + date.getMonth().toString().padStart( 2, '0' ) + '-' + date.getDate().toString().padStart( 2, '0' );
    },

    timeAgo : function( time ){
       
        const 
            date = new Date(),
            now = date.getTime() - ( date.getTimezoneOffset() * 60000 ) / 1000
            periods = [ 'segundo', 'minuto', 'hora', 'dia', 'semana', 'mês', 'ano', 'década' ],
            lengths = [ '60', '60', '24', '7', '4.35', '12', '10' ]
        ;

        var difference  = ( now - time ) / 1000;
        if( difference < 0 ) difference *= -1;

        for( var j = 0; difference >= lengths[ j ] && j < lengths.length -1; j++ ){
            difference /= lengths[ j ];
        }

        difference = Math.round( difference );

        if( difference != 1 ){
            if( periods[ j ] === 'mês' ){
                periods[ j ] = 'meses';
            }
            else {
                periods[ j ] += 's';
            }
        }

        return difference + ' ' + periods[ j ] + ' atrás';
    
    }

};
window.addEventListener( 'load', ( event ) => {
    Dates.init();
});

